<template>
  <div :class="['offcanvas', {'offcanvas--opened': isOpen}]">
    <span @click="closeOffcanvas" class="offcanvas-close"></span>
    <ul class="offcanvas-menu">
      <li class="offcanvas-menu__link">
        <router-link id="offcanvas-do-que-estamos-falando" to="/do-que-estamos-falando">
          Do que <span>estamos falando</span>
        </router-link>
      </li>

      <li class="offcanvas-menu__link">
        <router-link id="offcanvas-reforma-tributaria" to="/reforma-tributaria">
          Reforma <span>Tributária</span>
        </router-link>
      </li>

      <li class="offcanvas-menu__link">
        <router-link id="offcanvas-como-fizemos-as-contas" to="/como-fizemos-as-contas">
          Como fizemos <span>as contas</span>
        </router-link>
      </li>

      <li class="offcanvas-menu__link">
        <router-link id="offcanvas-perguntas-e-respostas" to="/perguntas-e-respostas">
          Perguntas <span>& Respostas</span>
        </router-link>
      </li>

      <li class="offcanvas-menu__link offcanvas-menu__link--highlight">
        <a @click="goToCalculator" href="/calculadora" id="offcanvas-calculadora">
          <svg class="offcanvas-menu__calculator-icon">
            <use xlink:href="#icon-calculator" />
          </svg>
          <span>Calcule aqui o <br/>valor do seu imposto</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  methods: {
    closeOffcanvas() {
      this.$store.dispatch('offcanvas/toggle');
    },
    goToCalculator(event) {
      event.preventDefault();

      if (this.$route.name == 'home') {
        window.scrollBy({
          top: window.innerHeight,
          left: 0,
          behavior: 'smooth',
        });

        this.$store.dispatch('offcanvas/close');
      } else {
        this.$router.push({
          path: '/calculadora',
        });
      }
    },
  },
  computed: {
    isOpen() {
      return this.$store.state.offcanvas.isOpen;
    },
  },
};
</script>

<style lang="scss">
.offcanvas {
  position: fixed;
  top: 0;
  right: 0;

  width: rem-calc(220);
  height: 100%;

  z-index: $z-index-offcanvas;
  background-color: $minsk;

  transform: translate(100%, 0);
  transition: transform ease 0.3s, box-shadow ease 0.3s;

  @media #{$large-up} {
    display: none;
  }
}

.offcanvas-close {
  position: absolute;
  top: rem-calc(35);
  right: rem-calc(20);
  width: rem-calc(20);
  height: rem-calc(20);
  cursor: pointer;

  opacity: 0;
  transition: opacity 0.3s ease;
  transition-delay: 0.3s;

  .offcanvas--opened & {
    opacity: 1;
  }

  &:after,
  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;

    width: rem-calc(20);
    height: 1px;

    background-color: $white;
  }

  &:after {
    transform: translate(-50%, -50%) rotate(45deg);
  }

  &:before {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
}

.offcanvas--opened {
  transform: translate(0, 0);
  box-shadow: rem-calc(-20 2 32) rgba($black, 0.5);
}

.offcanvas-menu {
  display: flex;
  flex-direction: column;
  padding: rem-calc(85 35);
}

.offcanvas-menu__link {
  opacity: 0;
  margin-bottom: rem-calc(20);
  transform: translate(rem-calc(-20), 0);
  transition: opacity 0.3s ease, transform 0.3s ease;

  &:last-child {
    margin-bottom: 0;
  }

  a {
    color: $white;
    font-size: rem-calc(16);
    line-height: rem-calc(20);
    font-family: 'oxfam-regular';

    &.router-link-active {
      color: $turmeric;
    }
  }

  span {
    display: block;
  }
}

@for $i from 0 through 5 {
  $delay: ($i * 0.1);

  .offcanvas--opened {
    .offcanvas-menu__link {
      &:nth-child(#{$i}) {
        opacity: 1;
        transform: translate(0, 0);
        transition-delay: #{$delay}s;
      }
    }
  }
}

.offcanvas-menu__link--highlight {
  display: block;
  margin-left: 0;

  @media #{$large-up} {
    margin-right: 0;
    margin-left: rem-calc(20);
  }

  a {
    display: flex;
    align-items: center;
    padding: rem-calc(5 10);

    font-size: rem-calc(12);
    line-height: rem-calc(12);

    border: 1px solid $turmeric;
    border-radius: rem-calc(30);

    span {
      color: $turmeric;
    }
  }
}

.offcanvas-menu__calculator-icon {
  width: rem-calc(12);
  height: rem-calc(16);

  margin-right: rem-calc(5);
}
</style>
